import { MainFlowActionTypes } from "./types";

export function getEmailList(id: string) {
  return {
    type: MainFlowActionTypes.GET_EMAIL_LIST_FOR_MAIN_FLOW,
    payload: { id },
  };
}

export function setEmailList(data: []) {
  return {
    type: MainFlowActionTypes.SET_EMAIL_LIST_FOR_MAIN_FLOW,
    payload: data,
  };
}

export function cancelEmailMainFlow(id: string) {
  return {
    type: MainFlowActionTypes.CANCEL_SESSION_MAIN_FLOW,
    payload: { id },
  };
}

export function setPinCheckError() {
  return {
    type: MainFlowActionTypes.SET_PIN_CHECK_ERROR_FOR_MAIN_FLOW,
  };
}
export function resetPinCheckError() {
  return {
    type: MainFlowActionTypes.RESET_PIN_CHECK_ERROR_FOR_MAIN_FLOW,
  };
}

export function setLoadingMainFlow() {
  return {
    type: MainFlowActionTypes.SET_BTN_LOADING,
  };
}
export function cleanLoadingMainFlow() {
  return {
    type: MainFlowActionTypes.CLEAN_BTN_LOADING,
  };
}

export function confirmEmailMainFlow(id: string, email: string) {
  return {
    type: MainFlowActionTypes.CONFIRM_EMAIL_MAIN_FLOW,
    payload: { id, email },
  };
}
export function confirmMainSource(session: string, source: string) {
  return {
    type: MainFlowActionTypes.CONFIRM_SOURCES,
    payload: { sessionId: session, sessionSource: source },
  };
}

export function setMainSources(sources: string[], contactValue: string) {
  return {
    type: MainFlowActionTypes.SET_SOURCES,
    payload: { sources, contactValue },
  };
}
export function getMainSources(payload: string) {
  return {
    type: MainFlowActionTypes.GET_SOURCES,
    payload,
  };
}
